<form class="merchant-details" [formGroup]="form_bank_data" (submit)="submit()">
  <div class="info-modal">
    <div
      class="modal-header"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutAlign.lt-md="start center"
    >
      <button
        class="icon-back mr-3 d-none d-medium"
        matPreffix
        mat-icon-button
        aria-label="Back"
        mat-dialog-close
      >
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <h2>{{ "merchants.modal.infoDataBank.title" | translate }}</h2>
      <div class="close" mat-dialog-close>
        <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
      </div>
    </div>
    <div class="modal-content mob-fixed-button">
      <div
        fxLayout="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-md="center center"
      >
        <div class="fs-18 fc-3 mb-3 text-center">
          {{ "merchants.modal.infoDataBank.subtitle" | translate }}
        </div>
        <div class="fs-14 fc-6 mb-3 text-center info">
          {{ "merchants.modal.infoDataBank.info" | translate }}
        </div>
      </div>

      <div class="mb-4" formGroupName="bank_accounts">
        <div
          fxFlex
          fxLayout="row"
          fxLayoutAlign="center center"
          class="method-pix"
        >
          <div class="fs-14 fc-9">
            <div fxFlex fxLayoutGap="20" fxLayoutAlign="center center" class="info-inputs">
              <mat-form-field fxFlex>
                <mat-label>{{
                  "merchants.edit.bankInfo.accountType" | translate
                }}</mat-label>
                <mat-select formControlName="account_type">
                  <mat-option value="P">{{
                    "merchants.edit.accountType.payment" | translate
                  }}</mat-option>
                  <mat-option value="C">{{
                    "merchants.edit.accountType.checking" | translate
                  }}</mat-option>
                  <mat-option value="S">{{
                    "merchants.edit.accountType.saving" | translate
                  }}</mat-option>
                  <mat-option value="D">{{
                    "merchants.edit.accountType.deposit" | translate
                  }}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    this.form_bank_data.get('bank_accounts').get('account_type')
                      .errors?.required
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.accountType.required"
                      | translate
                  }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{
                  "merchants.edit.bankInfo.bank" | translate
                }}</mat-label>
                <input
                  matInput
                  aria-label="Bank"
                  [matAutocomplete]="auto"
                  [formControl]="
                    this.form_bank_data.get('bank_accounts').get('bank_code')
                  "
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayBankName.bind(this)"
                >
                  <mat-option
                    *ngFor="let bank of filteredBank | async"
                    [value]="bank.bank_code"
                  >
                    <span
                      [innerHTML]="
                        bank.bank_code + ' - ' + bank.name
                          | highlight : bankToHighlight
                      "
                    ></span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error
                  *ngIf="
                    form_bank_data.get('bank_accounts')?.get('bank_code').errors
                      ?.required
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.bankCode.required"
                      | translate
                  }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{
                  "merchants.edit.bankInfo.agency" | translate
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="agency"
                  maxlength="4"
                />
                <mat-error
                  *ngIf="
                    form_bank_data.get('bank_accounts')?.get('agency').errors
                      ?.required
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.agency.required"
                      | translate
                  }}
                </mat-error>
                <mat-error
                  *ngIf="
                    form_bank_data.get('bank_accounts')?.get('agency').errors
                      ?.maxlength
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.agency.length"
                      | translate
                  }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{
                  "merchants.edit.bankInfo.account" | translate
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="number"
                  maxlength="20"
                />
                <mat-error
                  *ngIf="
                    this.form_bank_data.get('bank_accounts').get('number')
                      .errors?.required
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.account.required"
                      | translate
                  }}
                </mat-error>
                <mat-error
                  *ngIf="
                    this.form_bank_data.get('bank_accounts').get('number')
                      .errors?.maxlength
                  "
                >
                  {{
                    "merchants.edit.validation.bankAccounts.agency.length"
                      | translate
                  }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-footer"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <a mat-dialog-close fxShow fxHide.lt-md>{{
        "settings.users.modals.user.actions.cancel" | translate
      }}</a>
      <button [disabled]="model.user.isViewer || !form_bank_data.valid" mat-flat-button color="primary">
        {{ "merchants.modal.infoDataBank.button" | translate }}
      </button>
    </div>
  </div>
</form>
